import React from "react";
import {
  ANTRIAN_DISPLAY,
  ANTRIAN_QUEUE,
  FAR_CALL,
  KAS_CALL,
  LAY_CALL,
  LOC_CALL,
  POLI_CALL,
} from "App/constants";
import {
  AntrianDisplay,
  FarmasiCall,
  KasirCall,
  LayananCall,
  LoketCallAntrian,
  PoliCall,
  QueueAntrian,
} from "../WrapperLazyExport";

export const menuAntrian = {
  [ANTRIAN_DISPLAY]: <AntrianDisplay />,
  [ANTRIAN_QUEUE]: <QueueAntrian />,

  //ANTRIAN LOKET
  [LOC_CALL]: <LoketCallAntrian />,
  [POLI_CALL]: <PoliCall />,
  [LAY_CALL]: <LayananCall />,
  [FAR_CALL]: <FarmasiCall />,
  [KAS_CALL]: <KasirCall />,
};
